//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import api from "@/services/api";
import { server } from "@/services/constants";

export default {
    name: "clientTimeLineStatus",
    data(vm) {
        return {
            dialogDelete: false,
            delData: {},
            dialogAdd: false,
            text_color: "text-h5 green--text text-center",
            title: "green",
            message: "green",
            link: "",
            id_del: 0,
            search: "",
            leave_type: "",
            dialogDelete: false,
            authorize_view: false,
            authorize_add: false,
            authorize_edit: false,
            authorize_del: false,
            toggleEnable: false,
            selectstatus: "",
            mDataArray: [],
            authorize: [],
            headers: [

                {
                    text: "",
                    value: "actions",
                    align: "center",
                    class: "bg-colorth tabletextwhite",
                    divider: true,
                },
                {
                    text: "Module Name",
                    value: "module_name",
                    class: "bg-colorth tabletextwhite",
                    align: "start",
                    divider: true,
                },
                {
                    text: "Sequence",
                    value: "sequence",
                    class: "bg-colorth tabletextwhite",
                    align: "start",
                    divider: true,
                },
                {
                    text: "Timeline Status",
                    value: "status",
                    class: "bg-colorth tabletextwhite",
                    align: "start",
                    divider: true,
                },

                {
                    text: "Module Status",
                    value: "descriptions",
                    class: "bg-colorth tabletextwhite",
                    align: "start",
                    divider: true,
                },
                {
                    text: "Module Number",
                    value: "module_id",
                    class: "bg-colorth tabletextwhite",
                    align: "end",
                    divider: true,
                },


            ],
            dialogAddData: false,
            dataItem: {
                timeline_status_id: null,
                module_name: null,
                sequence: null,
                descriptions: null,
                module_id: null,
            },
            modeActions: "",
            timeLineStatusList: [],
            moduleList: ["Trademark Docket", "Patent Docket", "Dispute Resolution", "Corporate", "Immigration"]
        };
    },
    async beforeCreate() {
        console.log("beforeCreate");
        this.$store.state.navMenu = true;
    },
    beforeUpdate() { },
    components: {
        SuccessDialog,
        SuccessDialogPush,
    },
    computed: {
        itemsForSelected() {
            if (this.search.length) {
                return this.dataSource.filter((item) => this.search.includes(item));
            }
            return this.dataSource;
        },
    },
    async mounted() {
        // await api.checkVersion();
        // this.userId = localStorage.getItem(server.USER_ID);
        // let yourUrlString = window.location;

        // let parser = document.createElement("a");
        // parser.href = yourUrlString;

        // this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

        // // alert("authorize_id:" + this.authorize_id);
        // if (this.authorize_id == null || this.authorize_id == 0) {
        //     // this.$router.push("/login");
        //     this.$store.state.global_dialog = true;
        //     this.setupAlertDialog(
        //         true,
        //         "Authorize Failed!!!",
        //         "Please Logout And Login Again!!!",
        //         "text-h5 red--text text-center"
        //     );
        //     this.$router.back();
        // }

        // const router_path = parser.pathname.replace("/", "");

        // const res_auth = await api.getAuthorize(this.userId, router_path);


        // this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
        // this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
        // this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
        // this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;



        // if (!this.authorize_view) {
        //     this.$router.back();
        // }

        // // ----------------- Check Authorize ---------------------------

        // let comp_id = localStorage.getItem(server.COMPANYID);

        // this.userId = localStorage.getItem(server.USER_ID);
        // if (this.userId && api.isLoggedIn()) {
        //     // this.$router.push("/");
        // } else {
        //     this.$store.state.isLogged = false;
        //     this.$router.push("/login");
        // }

        //load data
        try {
            await this.loaddataTimeLineStatus();
            await this.loaddata();
        } catch (err) {
            alert("error")
            console.error(err);
        } finally {
            this.$hideLoader();
        }


    },
    methods: {
        async loaddataTimeLineStatus() {
            const result = await api.getClientTimelineStatus()

            if (result.data && result.data.length > 0) {
                this.timeLineStatusList = result.data
            }
        },
        async loaddata() {
            const result = await api.getClientTimelineStatusCongFigSql()

            if (result.data && result.data.length > 0) {
                this.mDataArray = result.data
            }
            console.log(this.mDataArray)

        },
        opendialogAdd() {
            this.modeActions = "New"
            this.dataItem = {
                timeline_status_id: null,
                module_name: null,
                sequence: null,
                descriptions: null,
                module_id: null,
            };
            this.dialogAddData = true;
        },
        closeaddItem() {
            this.dataItem = {
                timeline_status_id: null,
                module_name: null,
                sequence: null,
                descriptions: null,
                module_id: null,
            };
            this.dialogAddData = false;
        },

        openeditItem(data) {
            this.modeActions = "Edit";

            this.dataItem = { ...data };

            this.dialogAddData = true;
        },

        async saveaddItem() {

            // timeline status
            if (!this.dataItem.timeline_status_id) {

                this.$store.state.global_dialog = true;

                this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please select Status",
                    "text-h5 red--text text-center"
                );

                return;
            }

            // module
            if (!this.dataItem.module_name) {

                this.$store.state.global_dialog = true;

                this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please select Module",
                    "text-h5 red--text text-center"
                );

                return;
            }

            // sequence
            if (
                this.dataItem.sequence === null ||
                this.dataItem.sequence === undefined ||
                this.dataItem.sequence === ""
            ) {

                this.$store.state.global_dialog = true;

                this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please enter Sequence",
                    "text-h5 red--text text-center"
                );

                return;
            }

            // descriptions
            if (
                !this.dataItem.descriptions ||
                !this.dataItem.descriptions.trim()
            ) {

                this.$store.state.global_dialog = true;

                this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please enter Descriptions",
                    "text-h5 red--text text-center"
                );

                return;
            }

            // module id
            if (
                this.dataItem.module_id === null ||
                this.dataItem.module_id === undefined ||
                this.dataItem.module_id === ""
            ) {

                this.$store.state.global_dialog = true;

                this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please enter Module Number",
                    "text-h5 red--text text-center"
                );

                return;
            }
            if (this.modeActions == "New") {
                const check_duplications = await api.getClientTimelineStatusCheckDuplications({
                    params: {
                        timeline_status_id: this.dataItem.timeline_status_id,
                        module_name: this.dataItem.module_name
                    }
                })
                if (check_duplications.data && check_duplications.data.length > 0) {
                    this.$store.state.global_dialog = true;

                    this.setupAlertDialog(
                        true,
                        "Failed",
                        "This Module + Status already exists",
                        "text-h5 red--text text-center"
                    );

                    return;
                }

                const check_moduleNumber = await api.getClientTimelineStatusCongFigByModule(this.dataItem.module_name);

                const isDuplicate = check_moduleNumber.data.some(
                    item => Number(item.module_id) === Number(this.dataItem.module_id)
                );


                if (isDuplicate) {
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                        true,
                        "Failed",
                        "Module Number already exists in this module",
                        "text-h5 red--text text-center"
                    );

                    return;
                }
            }
            try {

                this.$showLoader();

                let data = null;

                if (this.modeActions == "New") {


                    const response = await api.createClientTimelineStatusCongFig(this.dataItem);

                    data = response.data;

                } else {


                    const response = await api.updateClientTimelineStatusCongFig(
                        this.dataItem.timeline_status_id,
                        this.dataItem
                    );

                    data = response.data;
                }

                if (data.success) {

                    this.closeaddItem();

                    this.$store.state.global_dialog = true;

                    this.setupAlertDialog(
                        true,
                        "Success",
                        "Saved successfully",
                        "text-h5 green--text text-center"
                    );

                    await this.loaddata();
                }



            } catch (err) {

                console.error(err);

                this.$store.state.global_dialog = true;

                this.setupAlertDialog(
                    true,
                    "Failed",
                    "Cannot save data",
                    "text-h5 red--text text-center"
                );

            } finally {

                this.$hideLoader();

            }
        },
        async onChangeModule(value) {
            this.$showLoader()
            const result = await api.getClientTimelineStatusCongFigByModule(value)

            if (result.status == 200) {
                if (result.data.length > 0) {
                    this.dataItem.sequence = Number(result.data.length + 1)
                    const maxModuleId = Math.max(
                        ...result.data.map(item => Number(item.module_id || 0))
                    );
                    this.dataItem.module_id = maxModuleId + 1
                } else {
                    this.dataItem.sequence = 1
                    this.dataItem.module_id = 1
                }
            } else {
                this.dataItem.sequence = null;
            }
            this.$hideLoader()
        },
        opendeleteItem(data) {
            this.dialogDelete = true;
            this.delData = {
                module_name: data.module_name,
                timeline_status_id: data.timeline_status_id,
            }
        },
        closeDelete() {
            this.dialogDelete = false;
        },
        async deleteItemConfirm() {
            // 1. validate ก่อน
            if (!this.delData?.module_name || !this.delData?.timeline_status_id) {
                this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please select Module and Status",
                    "text-h5 red--text text-center"
                )
                return
            }

            try {
                this.$showLoader()

                // 2. call API
                const result = await api.deleteClientTimelineStatusCongFig({
                    module_name: this.delData.module_name,
                    timeline_status_id: this.delData.timeline_status_id
                })

                // 3. success check
                if (result?.data?.success) {
                    this.setupAlertDialog(
                        true,
                        "Success",
                        "Deleted successfully",
                        "text-h5 green--text text-center"
                    )

                    await this.loaddata() // reload table
                } else {
                    this.setupAlertDialog(
                        true,
                        "Failed",
                        "Delete not success",
                        "text-h5 red--text text-center"
                    )
                }

            } catch (err) {
                console.error(err)

                // 4. error case
                this.setupAlertDialog(
                    true,
                    "Failed",
                    "Server error / Cannot delete data",
                    "text-h5 red--text text-center"
                )

            } finally {
                this.dialogDelete = false;
                this.$hideLoader()
            }
        },
        setupAlertDialog(status, title, message, text_color) {
            this.title = title;
            this.message = message;
            this.dialogAdd = status;
            this.text_color = text_color;
        },
        setupAlertDialogPush(status, title, message, text_color, link) {
            this.title = title;
            this.message = message;
            this.dialogAdd = status;
            this.text_color = text_color;
            this.link = link;
        },

    },
};
